import React from "react";
import FunctionDefinedComponents, {RolledChildType} from "../handler-components/FunctionDefinedComponents";

interface state {
    name: string,
}

interface props {
    name: string,
    children: any
}

export default class ClientNameSetComponents extends FunctionDefinedComponents <props, state> {

    constructor(props: any) {
        super(props);
        this.state = {
            name: props.name
        }
    }

    componentDidUpdate(prevProps: Readonly<props>, prevState: Readonly<state>, snapshot?: any) {
        if(prevProps.name != this.props.name)
            this.setState({
                name: this.props.name
            });
    }

    save() {
        this.appContext.fetch.Auth.requests.setName(this.state.name).then(res=>{
            this.appContext.snackBarData?.events?.success("نام با موفقیت ذخیره شد")
        });
    }

    rolledChildren(): RolledChildType {
        return [
            {
                role: "input",
                visible: true,
                props: {
                    value: this.state.name,
                    placeholder: "نام و نام خانوادگی",
                    onChangeText: (t:string) => {
                        this.setState({name: t});
                    }
                },
                children: null,
            },
            {
                role: "button-save",
                visible: true,
                props: {
                    onPress: ()=>{
                        this.save()
                    }
                },
                children: null,
            },
        ];
    }

}
